import { render } from "./UserTransactions.vue?vue&type=template&id=2073e866&scoped=true"
import script from "./UserTransactions.vue?vue&type=script&lang=js"
export * from "./UserTransactions.vue?vue&type=script&lang=js"

import "./UserTransactions.vue?vue&type=style&index=0&id=2073e866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2073e866"]])

export default __exports__